import React, { useState, useEffect } from "react";
import { PlusMinus } from "@/components/PlusMinus";
import { Money } from "@/helpers/Money";

interface QuantitySelectorProps {
  value: number;
  size?: string;
  price: Money; // Updated to receive variantPrice directly
  label?: string;
  onChange?: ((value: number | null) => void) | undefined;
}

const QuantitySelector = ({
  value,
  size,
  price, // variantPrice from parent
  label,
  onChange,
}: QuantitySelectorProps) => {
  const [currValue, setCurrValue] = useState(value);

  // Calculate the total price based on current quantity and variant price
  const totalPrice = price.mul(currValue);

  useEffect(() => {
    setCurrValue(value);
  }, [value]);

  return (
    <div>
      {label && (
        <label className="subtitle mb-4 text-base font-semibold">{label}</label>
      )}
      <div className="flex items-center justify-between rounded-lg border border-solid border-primary-200 p-4">
        <PlusMinus
          value={currValue}
          min={1}
          max={100}
          enableTrash={false}
          decrement={() => {
            setCurrValue(currValue - 1);
            onChange?.(currValue - 1);
          }}
          increment={() => {
            setCurrValue(currValue + 1);
            onChange?.(currValue + 1);
          }}
        />
        {size && (
          <p className="body mx-2 text-center text-sm italic">
            {currValue} x {size}
          </p>
        )}
        <p className="body text-sm font-semibold">
          {totalPrice.format()} {/* Updated to use the computed total price */}
        </p>
      </div>
    </div>
  );
};

export { QuantitySelector };
